// @flow

import React from 'react';
import { connectHits } from 'react-instantsearch-dom';

import CardClub from 'components/fragments/card/CardClub';
import type { ClubPreviewType, SearchClub } from 'types/Club';
import { sortClubs, getDisplayedClubs } from 'utils/clubUtils';
import { getDistanceFromLatLonInKm } from 'utils/distanceUtils';

type Props = {
    clubPerPage: number,
    currentPage: number,
    hits: Array<SearchClub>,
    practices: Array<string>,
    sort: string,
    userLatitude: number,
    userLongitude: number,
    maxDistance?: number,
};

export function hitToClubPreview(hit: SearchClub): ClubPreviewType {
    return {
        img: 'https://api-agregateur-static.ffr.fr/assets' + hit.embleme,
        name: hit.nom,
        searchName: hit.nom,
        lat: hit['Adresse.position'] ? hit['Adresse.position'].coordinates[1] : 0,
        long: hit['Adresse.position'] ? hit['Adresse.position'].coordinates[0] : 0,
        competitions: [],
        practices: hit.pratiques,
        adress: {
            complement: '',
            street: '',
            postalCode: hit['Adresse.codePostal'],
            locality: hit['Adresse.localite']
        },
        slug: hit.identifiant
    };
}

function Clubs({ clubPerPage, currentPage, hits, practices, sort, userLatitude, userLongitude, maxDistance }: Props) {
    const sortedClubs = sortClubs(hits.map(hitToClubPreview), sort, userLatitude, userLongitude).filter((club) => {
        if (!maxDistance) {
            return true;
        }

        const d = getDistanceFromLatLonInKm(userLatitude, userLongitude, club.lat, club.long);

        return (!club.lat && !club.long) || d <= maxDistance;
    });
    const displayedClubs = getDisplayedClubs(sortedClubs, clubPerPage, currentPage);

    return (
        <>
            {displayedClubs.map((club, index) => (
                <CardClub
                    searchedPractices={practices}
                    key={club.name}
                    club={club}
                    position={index + 1 + (currentPage - 1) * clubPerPage}
                    distance={(!!club.lat || !!club.long) && getDistanceFromLatLonInKm(userLatitude, userLongitude, club.lat, club.long)}
                />
            )
            )}
        </>
    );
}

export default connectHits(Clubs);